export default {
  /**
   * xlsx导出
   * @param {*} XLSX 核心api
   * @param {*} filename 文件名称
   * @param {object} data 数据源{key: Array}
   */
  xlsxFile(XLSX, filename, data) {
    // 创建workbook对象
    const wb = XLSX.utils.book_new();
    // 将srcData转换为worksheet
    for (let key in data) {
      const ws = XLSX.utils.aoa_to_sheet(data[key]);
      // worksheet 加入workbook
      XLSX.utils.book_append_sheet(wb, ws, key);
    }
    // 导出
    XLSX.writeFile(wb, `${filename}.xlsx`);
  }
};